export default __webpack_public_path__ + "static/social-banner-14f324efb9fe7318f0512575204b7c86.jpg";